/* Cordings — keyboard-vs-pointer focus tracking.
   Safari matches :focus-visible on a mouse/touch-focused <a> (WebKit
   treats links as keyboard-equivalent by default), so it shows a focus
   ring after every click, not just Tab navigation — Chrome/Firefox
   suppress it in that case. assets/globals.css keys its focus rings off
   `.wf-keyboard` on <html> instead of :focus-visible, so the ring only
   ever shows for real keyboard use, consistently across browsers. */
(function () {
  var root = document.documentElement;
  var IGNORED_KEYS = ['Alt', 'Control', 'Meta', 'Shift', 'OS'];

  function onKeydown(event) {
    if (IGNORED_KEYS.indexOf(event.key) === -1) root.classList.add('wf-keyboard');
  }

  function onPointer() {
    root.classList.remove('wf-keyboard');
  }

  document.addEventListener('keydown', onKeydown, true);
  document.addEventListener('mousedown', onPointer, true);
  document.addEventListener('pointerdown', onPointer, true);
  document.addEventListener('touchstart', onPointer, true);
})();
